import React from 'react'
import { withIcon } from '../../withIcon'

function LogoSherpaIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M20.52 7.56061L3.6071 17.2251L3.15644 16.4394L20.0693 6.77489L20.52 7.56061Z" fill={color}/>
      <path d="M12.2912 2.3355V21.6645H11.3852V2.3355H12.2912Z" fill={color}/>
      <path d="M20.52 16.4394L20.0693 17.2251L3.15644 7.56061L3.6071 6.77489L20.52 16.4394Z" fill={color}/>
      <path d="M11.1269 2.37324C11.4857 1.91408 12.1908 1.91408 12.5496 2.37324L12.6204 2.47824L20.5519 16.0737L20.6085 16.1881C20.8487 16.7692 20.4242 17.4363 19.7685 17.4363H3.90796C3.20873 17.4363 2.77241 16.6777 3.12461 16.0737L11.0561 2.47824L11.1269 2.37324ZM4.43413 16.2282H19.2423L11.8382 3.53294L4.43413 16.2282Z" fill={color}/>
      <path d="M12.5497 21.6267C12.1908 22.0859 11.4857 22.0859 11.1269 21.6267L11.0561 21.5218L3.12463 7.92632L3.068 7.81188C2.82778 7.23076 3.25228 6.56371 3.90798 6.56371L19.7685 6.56371C20.4678 6.56371 20.9041 7.32232 20.5519 7.92632L12.6204 21.5218L12.5497 21.6267ZM19.2424 7.77177L4.43415 7.77177L11.8383 20.4671L19.2424 7.77177Z" fill={color}/>
    </svg>
  )
}

export default withIcon(LogoSherpaIcon)
